import { render } from "./BaseInputForms.vue?vue&type=template&id=08f66b69"
import script from "./BaseInputForms.vue?vue&type=script&lang=js"
export * from "./BaseInputForms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__